import { useTranslation } from 'react-i18next';
import type { EquipmentRef } from '@apis/reports';
import { CardIcon } from '@components/Pages/AnalyticsPage/CardIcon';
import { DataRow } from './DataRow/DataRow';
import styles from './EquipmentSection.module.css';

interface IEquipmentSectionProps {
  equipment: EquipmentRef[];
  /** i18n key for the empty-state copy. Defaults to the Daily Route key;
   * Incident Report passes its own namespace. */
  emptyKey?: string;
}

export function EquipmentSection({
  equipment,
  emptyKey = 'reports.dailyRoute.empty.equipment',
}: IEquipmentSectionProps) {
  const { t } = useTranslation();
  if (equipment.length === 0) {
    return (
      <div role="status" className={styles.empty}>
        <CardIcon name="scissors-lift" size={16} />
        <span>{t(emptyKey)}</span>
      </div>
    );
  }
  return (
    <ul className={styles.list}>
      {equipment.map((e) => (
        <DataRow
          key={e.equipmentId}
          label={e.name}
          {...(e.type !== null ? { chip: { text: e.type } } : {})}
        />
      ))}
    </ul>
  );
}
